import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    flex: 0 0 100%;\n\n    ",
        " {\n      column-gap: 2rem;\n      flex: 0 0 calc(50% - 1rem);\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n    flex: 0 0 100%;\n\n    ",
        " {\n      column-gap: 2rem;\n      flex: 0 0 calc(50% - 1rem);\n    }\n\n    ",
        " {\n      column-gap: 2rem;\n      flex: 0 0 calc(33% - 1.75rem);\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Theme } from "@silvertours/front-shared";
var forColumns = function(columnCountForStyles) {
    return function(styles) {
        return function(param) {
            var antecedent = param.antecedent, columnCount = param.columnCount;
            return !antecedent && columnCount === columnCountForStyles && styles;
        };
    };
};
var ColumnContainer = /*#__PURE__*/ styled("div", {
    target: "e1xjftb50"
})("max-width:100%;", Theme.mq("md"), "{display:flex;flex-flow:row wrap;justify-content:space-between;column-gap:1.25rem;}");
var Column = /*#__PURE__*/ styled("div", {
    target: "e1xjftb51"
})("flex:", function(param) {
    var antecedent = param.antecedent;
    return antecedent || 1;
}, ";display:flex;flex-direction:column;gap:1.25rem;&:first-of-type{margin-bottom:1.25rem;", Theme.mq("md"), "{margin-bottom:0;}}", forColumns(2)(css(_templateObject(), Theme.mq("md"))), " ", forColumns(3)(css(_templateObject1(), Theme.mq("md"), Theme.mq("lg"))));
export { Column, ColumnContainer };
